import Link from "next/link";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  href: string;
};
export const MenuLink = ({ children, href }: Props) => {
  return (
    <Link
      href={href}
      className="text-sm/4 font-medium flex items-center px-1.5 py-1 rounded-sm transition-colors group whitespace-nowrap text-tx-1 stroke-tx-1 hover:bg-white/20"
    >
      {children}
    </Link>
  );
};
